import { fetchBanks, selectedBanks } from '@shared-core/features/backend'
import { useFocusEffect } from '@shared-core/navigation'
import { useAppDispatch, useAppSelector } from '@shared-core/store'
import { useCallback } from 'react'

export function useBanks() {
  const dispatch = useAppDispatch()
  const banks = useAppSelector(selectedBanks)

  useFocusEffect(
    useCallback(() => {
      void dispatch(fetchBanks())
      return undefined
    }, [dispatch]),
  )

  return banks
}
